export enum DocumentListComponentType {
  lead,
  activity,
  opportunity,
  assignment
}
